import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { configApi } from '../api/smartTokenizerApi';
import {
  explorerAddressUrl,
  explorerTokenUrl,
  explorerTransactionUrl
} from '../config/coreBlockchainExplorer';

const ClientConfigContext = createContext(null);

export function ClientConfigProvider({ children }) {
  const [blockExplorerBaseUrl, setBlockExplorerBaseUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await configApi.getClient();
        const u = data?.blockExplorerBaseUrl ?? data?.BlockExplorerBaseUrl ?? '';
        if (!cancelled) setBlockExplorerBaseUrl(String(u || '').trim());
      } catch {
        if (!cancelled) setBlockExplorerBaseUrl('');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => {
    const base = blockExplorerBaseUrl;
    return {
      blockExplorerBaseUrl: base,
      explorerConfigured: Boolean(base),
      addressExplorerUrl: (addr) => explorerAddressUrl(base, addr),
      tokenExplorerUrl: (contract, tokenId) => explorerTokenUrl(base, contract, tokenId),
      transactionExplorerUrl: (txHash) => explorerTransactionUrl(base, txHash)
    };
  }, [blockExplorerBaseUrl]);

  return <ClientConfigContext.Provider value={value}>{children}</ClientConfigContext.Provider>;
}

export function useClientConfig() {
  const ctx = useContext(ClientConfigContext);
  if (!ctx) {
    throw new Error('useClientConfig must be used within ClientConfigProvider');
  }
  return ctx;
}
